import * as yup from 'yup'
import { useState } from 'react'
import { ResendLinkForm } from './ResendLinkForm'
import { EnterEmailForm } from './EnterEmailForm'
import { FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { emailSchema, requiredError } from 'utils/validation'
import { useForm } from 'react-hook-form'
import { useSupabaseClient } from '@supabase/auth-helpers-react'
import { useCountdown } from 'components/Login/hooks/useCountdown'
import { useRouter } from 'next/router'
import { ParsedUrlQuery } from 'querystring'

const schema = yup.object({
  email: emailSchema.required(requiredError),
})

type MagicLinkFormSchema = yup.InferType<typeof schema>

export const MagicLinkForm = () => {
  const { query } = useRouter()
  const client = useSupabaseClient()
  const { countdown, triggerCountdown } = useCountdown()
  const formContext = useForm<MagicLinkFormSchema>({
    resolver: yupResolver(schema),
    mode: 'onChange',
  })
  const { watch } = formContext
  const email = watch('email')
  const [linkSent, setLinkSent] = useState(false)
  const [error, setError] = useState<string | unknown>('')

  const onSubmit = async () => {
    triggerCountdown()

    try {
      await client.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: `${window.location.origin}${getRedirectPath(query)}/?connectModal=true`,
        },
      })
      setLinkSent(true)
    } catch (error) {
      setError(error)
    }
  }

  if (error) {
    return (
      <div>
        <>Something went wrong: {error}</>
      </div>
    )
  }

  return (
    <FormProvider {...formContext}>
      {linkSent ? <ResendLinkForm onSubmit={onSubmit} countdown={countdown} /> : <EnterEmailForm onSubmit={onSubmit} />}
    </FormProvider>
  )
}

function getRedirectPath(query: ParsedUrlQuery) {
  return 'redirectTo' in query ? query.redirectTo : ''
}
